import InnerIoCContainer from './ioc/ioc.keys.class';
import { IoC } from './ioc/ioc/ioc.class';

export const IoCContainer: IoC = InnerIoCContainer;

//error handler classes what maybe needed before initializing IoC
export * from './classes/error-handling';

export * from './ioc/implentation/utils/deep-copy.class';

//pocos
export * from './pocos/list-item.class';
export * from './pocos/share-data.classes';
export * from './pocos/news.class';
export * from './pocos/sidebar-module.class';
export * from './pocos/sidebar.class';
export * from './pocos/sidebar-manager.class';
export * from './pocos/diagnostic.classes';

//models
export * from './models/contact-us-email.model';

//constans
export * from './constans/web-core.constans';

//abstract classes
export * from './classes/settings-storage/settings-storage-base.class';
export * from './classes/sensitive-settings-storage/sensitive-settings-storage-base.class';
export * from './classes/service-base/service-base.class';
export * from './ioc/base/settings/settings-base.class';
export * from './ioc/base/sensitive-settings/sensitive-settings-base.class';
export * from './classes/error-handling/dom-error-handler/dom-error-handler-base.class';
export * from './classes/templating/template-base.class';
export * from './classes/templating/template-renderer.class';

//interfaces
export * from './classes/settings-storage/settings-storage.interface';
export * from './classes/sensitive-settings-storage/sensitive-settings-storage.interface';
export * from './classes/error-handling/dom-error-handler/dom-error-handler.interface';

//sidebar
export * from './components/sidebar-component/sidebar-component.class';
export * from './components/sidebar-component/sidebar-manager-component.class';
export * from './components/sidebar-component/interfaces/sidebar-manager-component.interface';
export * from './components/sidebar-component/interfaces/sidebar-modul.interface';

//ioc
export * from './ioc/ioc.keys.class';
export * from './ioc/ioc/ioc.container.interface';
export * from './ioc/base/translation/translation.interface';
export * from './ioc/base/settings/settings.interface';
export * from './ioc/base/sensitive-settings/sensitive-settings.interface';
export * from './ioc/implentation/utils/utils.interface';
export * from './ioc/implentation/web-core-ioc-container/web-core-ioc-container.interface';
export * from './ioc/implentation/website-constants/website-constants.interfaces';
export * from './ioc/implentation/event-handler/event-handler.interface';
export * from './ioc/implentation/web-core-settings/web-core-settings.interface';
export * from './ioc/implentation/web-core-settings/web-core-settings.class';
export * from './ioc/implentation/web-core-sensitive-settings/web-core-sensitive-settings.interface';
export * from './ioc/implentation/web-core-sensitive-settings/web-core-sensitive-settings.class';
export * from './ioc/implentation/notification-service/notification-service.interface';
export * from './ioc/implentation/random-sentence-generator/random-sentence-generator.class';
export * from './ioc/implentation/random-sentence-generator/random-sentence-generator.interface';
export * from './ioc/implentation/asset-resolver/asset-resolver.class';
export * from './ioc/implentation/asset-resolver/asset-resolver.interface';
export * from './ioc/implentation/sidebar-css-provider/sidebar-css-provider.class';
export * from './ioc/implentation/sidebar-css-provider/sidebar-css-provider.interface';
export * from './ioc/shared-sidebar-modules/error-management-module';
